import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { siteInfo } from "@/mocks/site";
import SubscribeForm from "@/components/feature/SubscribeForm";

const siteLinks = [
  { label: "关于我们", path: "/about" },
  { label: "常见问题", path: "/faq" },
  { label: "热度榜单", path: "/ranking" },
  { label: "联系我们", path: "/contact" },
];

export default function Footer() {
  return (
    <footer className="mt-16 bg-primary-950 text-background-200">
      <div className="px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-background-50">
                <i className="ri-book-2-line text-lg"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50">{siteInfo.name}</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-300">{siteInfo.intro}</p>
            <p className="mt-4 flex items-center gap-2 text-sm text-background-300">
              <i className="ri-mail-line text-primary-300"></i>
              <a href={`mailto:${siteInfo.email}`} className="transition-colors hover:text-background-50">
                {siteInfo.email}
              </a>
            </p>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50">词条分类</h3>
            <ul className="mt-4 space-y-2.5 text-sm">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.id}`}
                    className="flex items-center gap-2 text-background-300 transition-colors hover:text-primary-200"
                  >
                    <i className={`${cat.icon} text-primary-400`}></i>
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50">站点导航</h3>
            <ul className="mt-4 space-y-2.5 text-sm">
              {siteLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-background-300 transition-colors hover:text-primary-200"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
            <p className="mt-5 text-xs leading-relaxed text-background-400">{siteInfo.replyTime}</p>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50">订阅每周更新</h3>
            <p className="mt-3 text-sm leading-relaxed text-background-300">
              每周一封邮件，汇总新增与更新的词条清单。
            </p>
            <div className="mt-4">
              <SubscribeForm />
            </div>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-4 border-t border-primary-800 pt-6 text-xs text-background-400 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 {siteInfo.name}. 保留所有权利。</p>
          <p className="max-w-2xl leading-relaxed">{siteInfo.disclaimer}</p>
        </div>
      </div>
    </footer>
  );
}